import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  { path: '/login', component: () => import('../views/Login.vue') },
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    redirect: '/sign',
    children: [
      { path: 'sign', component: () => import('../views/SignManage.vue'), meta: { title: '签到管理' } },
      { path: 'student', component: () => import('../views/StudentManage.vue'), meta: { title: '学生管理' } },
      { path: 'category', component: () => import('../views/CategoryManage.vue'), meta: { title: '分类管理' } },
      { path: 'report', component: () => import('../views/ReportManage.vue'), meta: { title: '学习汇报' } },
      { path: 'admin', component: () => import('../views/AdminManage.vue'), meta: { title: '管理员管理' } },
      { path: 'password', component: () => import('../views/ChangePassword.vue'), meta: { title: '修改密码' } }
    ]
  }
];

const router = new VueRouter({ routes });

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token');
  if (to.path !== '/login' && !token) next('/login');
  else next();
});

export default router;
